import { api } from "@/shared/api/instance";
import type {
  ManualFlightsQuery,
  ManualFlightsResponse,
} from "../types/manual-flight.types";
import { toast } from "sonner";

export const getManualFlights = async (
  query: ManualFlightsQuery = {}
): Promise<ManualFlightsResponse> => {
  const response = await api.get<ManualFlightsResponse>(
    "/api/v1/manual-flights",
    {
      params: query,
    }
  );
  return response.data;
};
export const deleteManualFlight = async (
  id: number
): Promise<ManualFlightsResponse> => {
  const response = await api.delete<ManualFlightsResponse>(
    `/api/v1/flights/${id}`
  );
  return response.data;
};
export const cancelManualFlight = async (
  id: number
): Promise<ManualFlightsResponse> => {
  const response = await api.put<ManualFlightsResponse>(
    `/api/v1/flights/${id}/cancel`
  );
  return response.data;
};
export const publishManualFlight = async (
  id: number
): Promise<ManualFlightsResponse> => {
  const response = await api.put<ManualFlightsResponse>(
    `/api/v1/flights/${id}/publish`
  );
  return response.data;
};

export const importManualFlightsCsv = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.post("/api/v1/manual-flights/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

const getFilenameFromDisposition = (cd?: string) => {
  if (!cd) return null;

  // content-disposition: attachment; filename="file.csv"
  const m = /filename\*?=(?:UTF-8''|")?([^;"\n]+)"?/i.exec(cd);
  return m?.[1] ? decodeURIComponent(m[1]) : null;
};

export const exportManualFlights = async () => {
    const res = await api.get("/api/v1/manual-flights/export", {
  
      responseType: "blob",
      headers: {
        Accept: "text/csv", // просим CSV [web:199]
      },
    });
  
    const cd = res.headers["content-disposition"];
    const filename = getFilenameFromDisposition(cd) ?? "manual-flights-export.csv";
  
    // на всякий случай приводим к правильному mime
    const blob = new Blob([res.data], { type: "text/csv;charset=utf-8" }); // charset опционален [web:199]
  
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    
  };
export const exportTemplateManualFlights = async () => {
    const res = await api.get("/api/v1/manual-flights/template", {
  
      responseType: "blob",
      headers: {
        Accept: "text/csv", // просим CSV [web:199]
      },
    });
  
    const cd = res.headers["content-disposition"];
    const filename = getFilenameFromDisposition(cd) ?? "manual-flights-template.csv";
  
    // на всякий случай приводим к правильному mime
    const blob = new Blob([res.data], { type: "text/csv;charset=utf-8" }); // charset опционален [web:199]
  
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    
  };
  